'use strict';

const jQuery = require('jquery');
const container = require('./../../../core/container');
const mediator = require('./../../../core/mediator');
const translator = require('./../../../core/translator');

const ContentRepository = require('./../../content/repository/ContentRepository');
const Loader = require('./../../../services/loader');
const PageRepository = require('./../repository/page');
const PopinManager = require('./../../../services/popin');
const Zone = require('./../../../services/structure/zone');

const onlineSwitchTpl = require('./../templates/menu_switch_item.hbs');

//
// variables declarations
//
const getSwitchIndicator = () => {
  return jQuery('#cloud-ui .cloud-toolbar-main .cloud-switch.online-switch .cloud-switch-indicator');
};

let currentPage = null;

const getCurrentPage = () => {
    let dfd = jQuery.Deferred();

    if (currentPage !== null) {
        dfd.resolve(currentPage);
    } else {
        PageRepository.find(container.get('page.uid')).done((page) => {
            currentPage = page;

            dfd.resolve(page);
        });
    }

    return dfd.promise();
};

let confirmPopin;

//
// functions declarations
//
module.exports.beforeRenderMenu = (item) => {
  if ('page-online-switch' === item.key) {
    let $item = jQuery(onlineSwitchTpl(item));
    item.html = $item;

    if (container.get('page.uid')) {
      getCurrentPage().done((page) => {
        let $checkbox = $item.find('input[type="checkbox"]');
        let text;

        if (page['is_online'] || page.type === 'home' || !container.get('isAllowedTo')('PUBLISH_PAGE')) {
          $item.find('.online-switch').addClass(page['is_online'] ? 'online' : 'offline');
          text = translator.translate(page['is_online'] ? 'page_online' : 'page_offline');
        } else {
          $item.find('.online-switch').addClass('has-checkbox');
          $item.find('.cloud-switch-indicator').removeClass('d-none');
          $checkbox.prop('checked', page['is_online']);
          text = translator.translate('put_online');
        }

        $item.find('.cloud-label').text(text);
      });
    }
  }
};

module.exports.onClick = () => {
  let data = {prevent: false};

  mediator.publish('before:put-online', data);

  if (getSwitchIndicator().hasClass('d-none') || data.prevent) {
    return;
  }

  if (confirmPopin && confirmPopin.invoke('isOpen')) {
    return;
  }

  let putOnline = !currentPage['is_online'];

  confirmPopin = PopinManager.createPopin({
    'title': translator.translate(`page_switch_${putOnline ? 'online' : 'offline'}_modal_title`),
    'minHeight': 50,
    'classes': {
      'ui-dialog': 'cloud-dialog has-icon-close',
    },
    'buttons': [
      {
        'class': 'popin popin-cancel',
        'text': translator.translate('cancel'),
        'click': function() {
            confirmPopin.hide();
        },
      },
      {
        'class': 'popin popin-ok',
        'text': translator.translate(`button_switch_page_${putOnline ? 'online' : 'offline'}`),
        'click': function() {
            confirmPopin.hide();

            Loader.start();

            ContentRepository.publish().done(function() {
              PageRepository.save(
                {'is_online': putOnline},
                {'uid': container.get('page.uid')},
              ).then(() => {
                window.location.reload();
              });
            });
        },
      },
    ],
  });

  Zone.hidePanels();

  let onlineMessage = jQuery('#cloud-ui .btn.btn-publish').hasClass('is-drafted')
  ? 'page_switch_online_and_save_modal_message'
  : 'page_switch_online_modal_message';

  let offlineMessage = 'page_switch_offline_modal_message';

  confirmPopin.setContent(`<p>${translator.translate(putOnline ? onlineMessage : offlineMessage)}</p>`);

  confirmPopin.display();
};
